import React from 'react';
import { motion } from 'framer-motion';
import { FlowerIcon } from './icons/Icons';
export const PromiseSection = () => {
  const promises = [{
    title: 'PRESENCIA TOTAL',
    desc: 'Cada vez que entras a nuestro studio, eres la única prioridad. Sin prisa. Sin protocolos genéricos. Tu tiempo y tu piel merecen atención completa.'
  }, {
    title: 'PROFESIONALISMO REAL',
    desc: 'María Fernanda es Esthetician certificada y Medical Assistant — dos expertises que se combinan para ofrecerte tratamientos seguros, efectivos y con respaldo profesional.'
  }, {
    title: 'RESULTADOS HONESTOS',
    desc: 'Si un tratamiento no es el correcto para ti en este momento, te lo diremos. Así se construye confianza real. Así se construyen clientes de por vida.'
  }];
  return <section className="py-12 md:py-16 bg-brand-cream relative border-t border-brand-gold/10" data-id="element-343">
      <div className="container mx-auto px-6 max-w-5xl text-center" data-id="element-344">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-8 md:mb-10" data-id="element-345">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-3" data-id="element-346">
            Nuestra Promesa
          </h2>
          <p className="text-lg md:text-xl text-brand-charcoal/80 max-w-2xl mx-auto" data-id="element-347">
            En Skin Glow Studio 22 no hacemos promesas que no podamos cumplir.{' '}
            <br data-id="element-348" />
            <span className="font-medium text-brand-bronze" data-id="element-349">
              Prometemos tres cosas:
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-350">
          {promises.map((promise, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="flex flex-col items-center" data-id="element-351">
              <div className="text-brand-gold mb-6" data-id="element-352">
                <FlowerIcon size={40} data-id="element-353" />
              </div>
              <h3 className="text-lg font-medium text-brand-charcoal mb-4 tracking-widest uppercase" data-id="element-354">
                {promise.title}
              </h3>
              <p className="text-brand-charcoal/70 leading-relaxed text-sm md:text-base" data-id="element-355">
                {promise.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};